_deleteHiddenContent